import { landmineNames } from '@mm/constants/landmine-names';
import { NewEmailAccount } from '@mm/state/interfaces/emailAccount';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFreeTrialUpgradeModal } from '../FreeTrialUpgradeModal/use-free-trial-upgrade-modal';

export const useActivateEmailAccount = () => {
  const { nativeIntegrations: hasNativeIntegrationsFeature } = useSelector(
    combinedFeatureFlagsSelector,
  );

  const { openConnectSendGridModal, openEmailAccountEditorModal } =
    useModalActions();
  const { openFreeTrialUpgradeModalPromotional } = useFreeTrialUpgradeModal();

  const connectSendgrid = useCallback(() => {
    if (!hasNativeIntegrationsFeature) {
      openFreeTrialUpgradeModalPromotional({
        landmineName: landmineNames.INTEGRATIONS_EMAIL,
      });
      return;
    }
    openConnectSendGridModal();
  }, [
    hasNativeIntegrationsFeature,
    openConnectSendGridModal,
    openFreeTrialUpgradeModalPromotional,
  ]);
  const connectManualAccount = useCallback(() => {
    if (!hasNativeIntegrationsFeature) {
      openFreeTrialUpgradeModalPromotional({
        landmineName: landmineNames.ACTIVATE_EMAIL_ACCOUNT_MANUAL,
      });
      return;
    }
    const defaultCustomEmailAccountConfig = {
      name: '',
      emailAddress: '',
      kind: 'custom',
      credential: {
        smtpServerParams: {
          address: '',
          port: 465,
          userName: '',
          password: '',
          enableSsl: true,
        },
        incomingServerType: 'imap',
        incomingServerParams: {
          address: '',
          port: 993,
          userName: '',
          password: '',
          enableSsl: true,
        },
      },
    } as NewEmailAccount;

    openEmailAccountEditorModal({
      emailAccountUnderEdit: defaultCustomEmailAccountConfig,
    });
  }, [
    openEmailAccountEditorModal,
    hasNativeIntegrationsFeature,
    openFreeTrialUpgradeModalPromotional,
  ]);

  return {
    connectSendgrid,
    connectManualAccount,
  };
};
